import type {
  PatientUserInfo,
  SessionClient,
  StorageClient,
  User,
  UserInfo,
} from "@phurshell/psiapp-frontend-core/domain";
import { useOffcanvasStore } from "@/store/useOffcanvasStore";
import { useChatRoomConfigStore } from "@/store/useChatRoomConfigStore";

export class SessionClientAdapter implements SessionClient {
  constructor(
    private readonly sessionStorage: StorageClient<User>,
    private readonly authTokenStorage: StorageClient<string>,
    private readonly userInfoStorage: StorageClient<UserInfo>,
  ) {}

  saveSession(params: User): void {
    this.sessionStorage.save("session", params);
  }

  getSession(): User | null {
    return this.sessionStorage.get("session");
  }

  updateSession(params: Partial<User>): void {
    this.sessionStorage.update("session", params);
  }

  destroySession(): void {
    this.sessionStorage.remove("session");
    this.authTokenStorage.remove("token");
    useOffcanvasStore().clear();
    useChatRoomConfigStore().clear();
  }

  saveAuthToken(token: string): void {
    this.authTokenStorage.save("token", token);
  }

  getAuthToken(): string {
    return this.authTokenStorage.get("token") || "";
  }

  getUserInfo(): UserInfo | null {
    return this.userInfoStorage.get("user_info");
  }

  getPatientUserInfo(): PatientUserInfo | null {
    return null;
  }

  updateUserInfo(params: Partial<UserInfo>): void {
    this.userInfoStorage.update("user_info", params);
  }
}
